import { type FormEvent, useState } from 'react';
import { useApi } from '@plataforma/web/api';
import { ETIQUETAS_RUTA, ETIQUETAS_SITUACION } from '../formato';
import { usePuede } from '../permisos';
import type { Vehiculo } from '../paginas/tipos';

/**
 * Ruta y situación legal (arquitectura 2.15): a dónde va el auto y cómo queda legalmente. La
 * situación «importado con pedimento» la pone la plataforma al registrar el pedimento y es el
 * sello que ve el comprador.
 */
export function RutaVehiculo({ v, alGuardar }: { v: Vehiculo; alGuardar: () => void }) {
  const api = useApi();
  const permitido = usePuede();
  const [error, setError] = useState<string | null>(null);
  const [abierto, setAbierto] = useState(false);
  const guardar = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const f = new FormData(e.currentTarget);
    setError(null);
    try {
      await api('PATCH', `/inventory/vehiculos/${v.id}/ruta`, {
        ruta: f.get('ruta'),
        situacionLegal: f.get('situacionLegal'),
        ...(String(f.get('nota') ?? '').trim() && { nota: String(f.get('nota')).trim() }),
      });
      setAbierto(false);
      alGuardar();
    } catch (err) {
      setError((err as Error).message);
    }
  };
  return (
    <section className="seccion">
      <header>
        <h2>Ruta y situación legal</h2>
        <div style={{ flex: 1 }} />
        {permitido('vehiculos.estado') && (
          <button className="boton" onClick={() => setAbierto((x) => !x)}>
            {abierto ? 'Cancelar' : 'Cambiar'}
          </button>
        )}
      </header>
      <div
        className="cuerpo"
        style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'center' }}
      >
        <span className="etiqueta">{ETIQUETAS_RUTA[v.ruta] ?? v.ruta}</span>
        <span
          className={`etiqueta ${v.situacionLegal === 'importado_pedimento' || v.situacionLegal === 'nacional' ? 'exito' : ''}`}
        >
          {ETIQUETAS_SITUACION[v.situacionLegal] ?? v.situacionLegal}
        </span>
        {v.situacionLegal === 'importado_pedimento' && (
          <span className="subtitulo">Se muestra como sello en la publicación</span>
        )}
      </div>
      {error && (
        <p className="error" style={{ margin: 16 }}>
          {error}
        </p>
      )}
      {abierto && (
        <form
          className="cuerpo formulario"
          onSubmit={(e) => void guardar(e)}
          style={{ borderTop: '1px solid var(--borde-suave)' }}
        >
          <label className="campo">
            <span>Ruta</span>
            <select name="ruta" defaultValue={v.ruta}>
              {Object.entries(ETIQUETAS_RUTA).map(([k, t]) => (
                <option key={k} value={k}>
                  {t}
                </option>
              ))}
            </select>
          </label>
          <label className="campo">
            <span>Situación legal</span>
            <select name="situacionLegal" defaultValue={v.situacionLegal}>
              {Object.entries(ETIQUETAS_SITUACION).map(([k, t]) => (
                <option key={k} value={k}>
                  {t}
                </option>
              ))}
            </select>
          </label>
          <label className="campo">
            <span>Nota</span>
            <input name="nota" maxLength={300} />
          </label>
          <div className="acciones">
            <button className="boton primario">Guardar</button>
          </div>
        </form>
      )}
    </section>
  );
}
